export { default as Price } from './Price'
